<span [ngSwitch]="type">
  <button class="google raised" *ngSwitchCase="'mat-raised-button'" [color]="color" mat-raised-button (click)="scanGMail()" [disabled]="scanning"
      angulartics2On="click" angularticsAction="ScanGMailClick" [angularticsCategory]="label">
    <img class="icon" *ngIf="!scanning" [src]="'/gmail_large.png' | assetUrl"/>
    <span *ngIf="scanning"><mat-spinner style="width: 16px; height: 16px"></mat-spinner></span>
    <span *ngIf="!scanning">{{label}}</span>
  </button>
  <button *ngSwitchDefault mat-button (click)="scanGMail()" [disabled]="scanning" angulartics2On="click" angularticsAction="ScanGMailClick" [angularticsCategory]="label">
    <span *ngIf="scanning"><mat-spinner style="width: 16px; height: 16px"></mat-spinner></span>
    <span *ngIf="!scanning">{{label}}</span>
  </button>
</span>
